import {API} from "@/Composables/api";

const authUser = async () => {
    return API.get(route("user"), {}, false);
};
const logIn = async (credentials) => {
    return API.post(route("login"), {}, credentials);
};

const registerUser = async (formData, group) => {
    return API.post(route("register"), {group}, formData);
};

const updatePassword = async (userId, formData, params = {}) => {
    return API.put(route("user.password.update", userId), params, formData);
};

const logOut = async () => {
    return API.post(route("logout"));
};

const forgotPassword = async (formData) => {
    return API.post(route("password.email"), {}, formData);
};

const resetPassword = async (formData) => {
    return API.post(route("password.store"), {}, formData);
};

const sendEmailVerification = async () => {
    return API.post(route("verification.send"));
};

const getInvitation = async (invitation, signature) => {
    return API.get(route("invitations.registration", [invitation, signature]), {}, false);
};

export {
    authUser,
    logIn,
    registerUser,
    updatePassword,
    logOut,
    forgotPassword,
    resetPassword,
    sendEmailVerification,
    getInvitation,
};
